export default __webpack_public_path__ + "static/media/crossWhite.svg";